<div class="modal-header">
    <h4 class="modal-title fw-bold">{{title | translate}}</h4>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
            (click)="closeModal()">
    </button>
</div>
<div class="modal-body">
    <div class="row mb-3">
        <div class="col-xs-12 col-md-12">
            <div class="table-responsive custom-scroll-style" style="max-height: 800px; overflow-y: auto;">
                <p-tree [value]="nodes"
                        (onNodeExpand)="onNodeExpand($event)"
                        [selectionMode]="selectionMode"
                        autoLayout="true"
                        [(selection)]="_selectedNodes"
                        (onNodeSelect)="onNodeSelect($event)"
                        styleClass="tree-table">
                    <ng-template pTemplate="default" let-node>
                        <span [ngClass]="{ 'folder': !node.leaf, 'file': node.leaf }"></span>
                        {{translateName(node.data)}}
                    </ng-template>
                </p-tree>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="closeModal()">{{ 'cancel' | translate}}</button>
    <button type="button" class="btn btn-primary" aria-hidden="true" (click)="finish()">{{'ok' | translate }}</button>
</div>
